import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Reset window scroll when the route pathname changes.
 * Prevents carrying scroll position across sidebar / in-app navigation.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  return null;
}
